<template>
    <Card :bordered="false" class="border-radius-0" :bodyStyle="{ padding: '24px 24px 0px 24px' }" v-if="has({ menuContext, key: 'forSendRequest' })">
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <Collapse v-model:activeKey="data.collapseUserRequestForm">
            <CollapsePanel :header="$t('model.licenseRequest.createRequestCollapse.title')" key="requestForm">
                <Row>
                    <Col :md="4" class="btn-request-license">
                        <a
                            ><Card
                                :bordered="true"
                                :bodyStyle="{ paddingLeft: '0px', paddingRight: '0px', borderRadius: '8px !important' }"
                                class="request-btn text-center h-80 blue-navy-color font-white"
                                @click="() => router.push({ name: `user-requests-create` })"
                            >
                                <CIcon file="resume.svg" style="font-size: 50px"></CIcon>
                                <div>
                                    <span>{{ $t("model.userRequest.editRegister") }}</span>
                                </div>
                            </Card></a
                        >
                    </Col>
                </Row>
            </CollapsePanel>
        </Collapse>
    </Card>

    <Card :bordered="false" class="border-radius-0">
        <CTable
            :isLoading="isLoading"
            v-model:columns="state.columns"
            v-model:page="state.page"
            :options="state.tableOptions"
            :manages="state.manages"
            :manageExtras="state.manageExtras"
            :rowActions="state.rowActions"
            @search="(search) => onSearch({ props, ...search })"
        ></CTable>
    </Card>
</template>

<script>
import { Card, Collapse, Row, Col } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../app.logic";
import { initState, isLoading, onSearch, state } from "./user-request-register-approve.logic";
import router from "../../../../router";
import { has } from "../../../../utils/menu-context";

export default defineComponent({
    components: {
        Row,
        Col,
        Card,
        Collapse,
        CollapsePanel: Collapse.Panel,
        CIcon: defineAsyncComponent(() => import("../../../../components/icon/CIcon")),
        CTable: defineAsyncComponent(() => import("../../../../components/table/CTable")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "user-requests" },
    },
    setup(props) {
        const data = reactive({ collapseUserRequestForm: "requestForm" });
        initState({ props, data });
        return { props, isLoading, state, onSearch, data, router, has };
    },
});
</script>

<style scoped>
.request-btn {
    border-radius: 8px !important;
}

.font-white {
    color: white !important;
}

.blue-navy-color {
    background-color: #1164b4 !important;
}
</style>
